import { useState } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

function App() {
  const [token, setToken] = useState(sessionStorage.getItem("adminToken") || "");
  const [email, setEmail] = useState(sessionStorage.getItem("adminEmail") || "");

  const handleLogin = (t, e) => {
    sessionStorage.setItem("adminToken", t);
    sessionStorage.setItem("adminEmail", e);
    setToken(t);
    setEmail(e);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setToken("");
    setEmail("");
  };

  if (!token) return <Login onLogin={handleLogin} />;
  return <Dashboard token={token} email={email} onLogout={handleLogout} />;
}

export default App;
